export default __webpack_public_path__ + "static/media/auth-decoration.33719348.png";